export enum ScrollLockIdE {
  TicketDetailsPopup = 'ticket-details-popup',
  OpenNewTicketPopup = 'open-new-ticket-popup',
  ColumnPickerPopup = 'column-picker-popup',
  FiltersPopup = 'filters-popup',
  TicketReopenPopup = 'ticket-reopen-popup',
  TicketApprovePopup = 'ticket-approve-popup',
  TicketClosePopup = 'ticket-close-popup',
  AddAttachmentPopup = 'add-attachment-popup',
  DeleteAttachmentPopup = 'delete-attachment-popup',
  ApproveAttachmentsPopup = 'approve-attachments-popup',
  ViewAttachmentsPopup = 'view-attachments-popup',
  ViewScheduleFilesPopup = 'view-schedule-files-popup',
  NotificationsHistoryPopup = 'notifications-history-popup',
  ChangeTicketClaimStatusPopup = 'change-ticket-claim-status-popup',
  ChangeTicketPriorityPopup = 'change-ticket-priority-popup',
  EulaPopup = 'eula-popup',
  DeleteTicketPopup = 'delete-ticket-popup',
  AppSelectorPopup = 'app-selector-popup',
  ImportSchedulePopup = 'import-schedule',
}
